<template>
  <el-dialog :title="isUpdate ? '编辑租户' : '添加租户'" :visible="visible" width="750px" :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :sm="12">
          <el-form-item label="所属租户:" prop="tenant_id">
            <el-select v-model="form.tenant_id" clearable filterable placeholder="请选择" class="ele-block"
              :disabled="isUpdate" @change="onTenantChange">
              <el-option v-for="item in tenantList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="登录账号:" prop="username">
            <el-input clearable :maxlength="20" v-model.trim="form.username" placeholder="请输入" :disabled="isUpdate" />
          </el-form-item>

          <el-form-item v-if="isUpdate" label="登录密码:" prop="password">
            <el-input show-password :maxlength="20" v-model.trim="form.password" placeholder="请输入" />
          </el-form-item>

          <el-form-item v-if="isUpdate" label="电子邮箱:" prop="email">
            <el-input clearable :maxlength="100" v-model.trim="form.email" placeholder="请输入" />
          </el-form-item>
        </el-col>

        <el-col :sm="12">
          <el-form-item v-if="isUpdate" label="手机号码:" prop="mobile">
            <el-input clearable :maxlength="11" v-model.trim="form.mobile" placeholder="请输入" />
          </el-form-item>

          <el-form-item label="租户角色:" prop="role_ids">
            <el-select multiple clearable v-model="form.role_ids" placeholder="请选择" class="ele-block"
              :disabled="!form.tenant_id">
              <el-option v-for="item in roleList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="isUpdate" label="状态:" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="isUpdate">
        <el-col :sm="24">
          <el-form-item label="登录IP:">
            <el-input :rows="3" clearable type="textarea" :maxlength="1000" v-model.trim="form.login_ip_str"
              placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import validate from 'ele-admin/packages/validate';
import { loadDictOptions } from '@/utils/dict';

export default {
  name: 'UserEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: { status: 1, role_ids: [] },
      rules: {
        tenant_id: [{ required: true, message: '请选择', trigger: 'change' }],
        username: [{ required: true, message: '请输入', trigger: 'blur' }],
        status: [{ required: true, message: '请选择', trigger: 'blur' }],
        role_ids: [{ required: true, message: '请选择', trigger: 'change' }],
        email: [{ pattern: validate.email, message: '邮箱格式不正确', trigger: 'blur' }],
        mobile: [{ pattern: validate.phone, message: '手机号格式不正确', trigger: 'blur' }]
      },
      loading: false,
      isUpdate: false,
      roleList: [],
      tenantList: [],
      statusOptions: []
    };
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({ status: 1 }, this.data, {
          tenant_id: this.data.tenant_id || null,
          role_ids: (this.data.roles || []).map(d => d.id),
          password: ''
        });
        this.isUpdate = true;
        this.queryRoles();
      } else {
        this.form = { status: 1, role_ids: [] };
        this.isUpdate = false;
        this.roleList = [];
      }
    }
  },
  mounted() {
    loadDictOptions('common_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
    this.queryTenants();
  },
  methods: {
    save() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.$http.post('/tenantadmin/edit', this.form).then(res => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    onTenantChange() {
      this.form.role_ids = [];
      this.queryRoles();
    },
    queryTenants() {
      this.$http.get('/tenant/options').then(res => {
        if (res.data.code === 0) {
          this.tenantList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    queryRoles() {
      const tenantId = this.form.tenant_id;
      if (!tenantId) {
        this.roleList = [];
        return;
      }
      this.$http.get('/role/getRoleList', { params: { tenant_id: tenantId } }).then(res => {
        if (res.data.code === 0) {
          this.roleList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    }
  }
};
</script>
